import { render, staticRenderFns } from "./holter_report.vue?vue&type=template&id=51cf3d6f&scoped=true"
import script from "./holter_report.vue?vue&type=script&lang=js"
export * from "./holter_report.vue?vue&type=script&lang=js"
import style0 from "./holter_report.vue?vue&type=style&index=0&id=51cf3d6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cf3d6f",
  null
  
)

export default component.exports